import moment from "moment";

class DateFormat {
  constructor() {
    return this.transform;
  }

  transform(date, format) {
    return moment(date).format(format);
  }
}

const dateFormatFnc = () => new DateFormat();

export default dateFormatFnc;



// WEBPACK FOOTER //
// ./src/filters/dateFormat/dateFormat.filter.js